<template>
  <v-container fluid class="pa-0">
    <!-- Header -->
    <v-toolbar flat dense>
      <template v-if="stageAccount.isStaged">
        <v-chip class="mr-4"><v-icon color="success">done</v-icon></v-chip>
      </template>
      <template v-else>
        <v-chip class="mr-4"><v-icon color="error">cancel</v-icon></v-chip>
      </template>
      <v-chip class="elevation-1 mr-4" dark :color="appColor_Medium">Staged: {{ stageAccount.animalCount }}</v-chip>
      <!-- <v-chip>Herds: {{ stageAccount.herdGroupCount }}</v-chip> -->
    </v-toolbar>
    <!-- File Picker -->
    <v-flex
      sm12
      class="mt-2"
      >
      <v-text-field
        v-model="stageAccount.fileName"
        label="CSV File"
        append-icon="attach_file"
        :disabled="isStaging"
        readonly
        @click="pickFile"
      />
      <input
        ref="filePicker"
        type="file"
        style="display: none"
        accept=".csv"
        @change="onFilePicked"
      />
    </v-flex>

    <!-- Error Dialog -->
    <v-dialog
      v-model="errorDialog"
      max-width="400px"
      >
      <app-error
        :error-title="'Staging Error'"
        :error-text="errorText"
        :error-severity="errorSeverity"
        @close="errorDialog = false"
      />
    </v-dialog>
  </v-container>
</template>

<script>
import appService from '@/app.service'
import { AppColor } from '@/config.js'
import AppError from '@/components/AppError'

export default {
  name: 'HerdtraxStager',
  components: {
    AppError
  },
  props: {
    stageAccount: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      appColor_Medium: AppColor.Medium,

      isStaging: false,
      isFile: false,
      errorDialog: false,
      errorText: ''
    }
  },
  computed: {
    fileSelected: function () {
      return (this.isFile)
    }
  },
  methods: {
    pickFile () {
      this.$refs.filePicker.click()
    },

    onFilePicked (e) {
      const self = this
      const files = e.target.files
      if (files[0] !== undefined) {
        self.stageAccount.fileName = files[0].name
        if (self.stageAccount.fileName.lastIndexOf('.') > 0) {
          const reader = new FileReader()
          reader.readAsDataURL(files[0])
          reader.addEventListener('load', () => {
            self.stageAccount.fileUrl = reader.result
            self.stageAccount.dataFile = files[0]
            self.isFile = self.stageAccount.dataFile.size > 0
            self.$emit('filePicked')
          })
        }
      }
    },

    stageData () {
      if (this.stageAccount.dataFile !== null) {
        const self = this
        const wasStaged = self.stageAccount.isStaged
        self.isStaging = true
        self.stageAccount.isStaged = false
        self.stageAccount.animalCount = 0
        self.stageAccount.herdGroupCount = 0
        self.$emit('staging')
        const formData = new FormData()
        formData.append(self.stageAccount.fileName, self.stageAccount.dataFile)
        appService.stageHerdtraxData(self.stageAccount.accountId, self.stageAccount.userId, formData).then((data) => {
          self.isStaging = false
          if (data.errorMessage.length === 0) {
            self.stageAccount.isStaged = true
            self.stageAccount.animalCount = data.stageControl.animalCount
            self.stageAccount.herdGroupCount = data.stageControl.herdGroupCount
            self.stageAccount.csvFilename = data.stageControl.csvFilename
            self.$emit('staged', { stageControl: data.stageControl })
          } else {
            self.errorText = data.errorMessage
            self.errorDialog = true
            self.stageAccount.isStaged = wasStaged
            self.$emit('staged', { stageControl: null })
          }
          self.resetInput()
        })
      }
    },

    getNumberFormat (x) {
      if (typeof x === 'undefined' || x === null) return '0'
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },

    resetInput () {
      this.$refs.filePicker.type = 'text'
      this.$refs.filePicker.type = 'file'
    }
  }
}
</script>

